import {Component} from "react";
import React from "react";
import SVG from "react-inlinesvg";
import closeicon from "../../assets/close.svg";
import './Functionality.css';
import $ from "jquery";
import {objectToFormData, post} from '../../utils/api';
import Loading from "../Shared/Loading";
import {connect} from "react-redux";
import {fetchSearchData} from "../../actions/searchActions";

class Functionality extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: this.props.record,
            creative_type_ids: [],
            functionality: this.props.functionality,
            functionalities: this.props.functionalities,
            name: this.props.functionality.name,
            action: this.props.action,
            errors: false
        };

        this.closeModal = this.closeModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleMultiCheckboxChange = this.handleMultiCheckboxChange.bind(this);
    }

    closeModal(e) {
        if (e.keyCode === 27) {
            this.props.toggleModal(false)
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.closeModal);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.closeModal);
        $("html, body").animate({scrollTop: 0}, 300);
    }


    handleSubmit(e) {
        e.preventDefault();
        this.props.setLoading(true);
        let data = objectToFormData( {
            id: this.state.functionality.id,
            name: this.state.name
        });
        this.setState({
            errors: false,
            loading: true,
        });
        post('manage/functionality/' + this.state.functionality.id, data).then((res) => {
            this.props.refreshFunctionality();
            this.props.toggleModal(false);
        }).catch(err => {
            this.setState({
                loading: false,
                errors: err.response.data.error_stack
            });
            this.props.setLoading(false);
        });
        this.props.dispatch(fetchSearchData());
    }


    handleCreate(e) {
        e.preventDefault();
        this.props.setLoading(true);
        let data = objectToFormData({
            creative_type_id: [this.state.record.creative_type_id, ...this.state.creative_type_ids],
            name: this.state.name
        });
        this.setState({
            errors: false,
            loading: true,
        });
        post('manage/functionality/', data).then((res) => {
            this.props.refreshFunctionality();
            this.props.toggleModal(false);
        }).catch(err => {
            this.setState({
                loading: false,
                errors: err.response.data.error_stack
            });
            this.props.setLoading(false);
        })
        this.props.dispatch(fetchSearchData());
    }

    handleDelete() {
        if (!window.confirm("Deleting this functionality will remove it from any unit using it. This cannot be undone. Are you sure?")) {
            return;
        }
        this.props.setLoading(true);
        this.setState({
            errors: false,
            loading: true,
        });
        post('manage/functionality/delete/' + this.state.functionality.id).then((res) => {
            this.props.refreshFunctionality();
            this.props.toggleModal(false);
        }).catch(err => {
            this.setState({
                loading: false,
                errors: err.response.data.error_stack
            });
            this.props.setLoading(false);
        })
        this.props.dispatch(fetchSearchData());
    }

    handleTextChange(e) {
        let value = e.target.value;
        let name = e.target.name;

        this.setState({
            [name]: value
        });
    }

    handleMultiCheckboxChange(e) {
        const {name, checked} = e.target;
        const value = parseInt(e.target.value);

        let creative_type_ids = this.state.creative_type_ids;

        if (checked) {
            if (!creative_type_ids.includes(value)) {
                creative_type_ids = [...creative_type_ids, value];
            }
        } else {
            creative_type_ids = creative_type_ids.filter(el => el !== value);
        }

        this.setState({creative_type_ids});
    }

    render() {

        return (
            <div className="modal-overlay">
                <section className="modal modal-function">
                    <div className="modal-content">
                        <div onClick={() => this.props.toggleModal(false)} className="closeBtn">
                            <SVG src={closeicon}/>
                        </div>
                        {this.state.errors &&
                        <ul className="error-list">
                            {this.state.errors.map((error, key) => (
                                <li key={key}>{error.msg}</li>
                            ))}
                        </ul>
                        }
                        {this.props.action === 'update' &&
                        <div className="modal-header">
                            <h1>Edit Functionality <br/>
                                {this.state.record.unit_type} - {this.state.record.creative_type}
                            </h1>
                        </div>
                        }
                        {this.props.action === 'create' &&
                        <div className="modal-header">
                            <h1>Create Functionality <br/>
                                {this.state.record.unit_type} - {this.state.record.creative_type}
                            </h1>
                        </div>
                        }
                        <div className="form-group">
                            <label>Functionality Name</label>
                            <input className="form-control" name="name" autoComplete="off"
                                   defaultValue={this.state.name} onChange={this.handleTextChange}/>
                        </div>
                        {this.props.action === 'create' &&
                        <div className="form-group">
                            <label>Include for:</label>
                            <ul className="extra-funcs">
                                <li><strong>Mock</strong></li>
                                {Object.keys(this.state.functionalities).sort().map((keyName, keyIndex) => {
                                    return (
                                        this.state.functionalities[keyName].map((func) => {
                                            var show = true;
                                            if (this.state.record.creative_type_id == func.creative_type_id || func.unit_type  === 'live') {
                                                show = false;
                                            }
                                            var f = func.functionalities.find(f => {
                                                return typeof this.state.name !== 'undefined' && f.name.toLowerCase() === this.state.name.toLowerCase()
                                            });

                                            if (show) {
                                                return (<li key={`${keyName}-${func.creative_type_id}`}
                                                            className={typeof f !== 'undefined' ? 'conflict' : ''}>
                                                    <label>
                                                        <input
                                                            onChange={this.handleMultiCheckboxChange}
                                                            value={func.creative_type_id}
                                                            type="checkbox"/> {func.creative_type}
                                                        <span>Functionality Already Exists</span>
                                                    </label></li>)
                                            }
                                        }))
                                })}
                            </ul>
                            <ul className="extra-funcs">
                                <li><strong>Live</strong></li>
                                {Object.keys(this.state.functionalities).sort().map((keyName, keyIndex) => {
                                    return (
                                        this.state.functionalities[keyName].map((func) => {
                                            var show = true;
                                            if (this.state.record.creative_type_id == func.creative_type_id || func.unit_type  === 'mock') {
                                                show = false;
                                            }
                                            var f = func.functionalities.find(f => {
                                                return typeof this.state.name !== 'undefined' && f.name.toLowerCase() === this.state.name.toLowerCase()
                                            });

                                            if (show) {
                                                return (<li key={`${keyName}-${func.creative_type_id}`}
                                                            className={typeof f !== 'undefined' ? 'conflict' : ''}>
                                                    <label>
                                                        <input
                                                            onChange={this.handleMultiCheckboxChange}
                                                            value={func.creative_type_id}
                                                            type="checkbox"/> {func.creative_type}
                                                        <span>Functionality Already Exists</span>
                                                    </label></li>)
                                            }
                                        }))
                                })}
                            </ul>
                        </div>
                        }
                        {this.state.action === 'update' &&
                        <div className="button-wrapper">
                            <button className="button button--transparent" type="button"
                                    onClick={() => this.props.toggleModal(false)}>
                                Cancel
                            </button>
                            <button className="button button--red" type="button" onClick={this.handleDelete}>
                                Delete
                            </button>
                            <button className="button button--blue" onClick={this.handleSubmit}>
                                Update
                            </button>
                        </div>
                        }
                        {this.state.action === 'create' &&
                        <div className="button-wrapper">
                            <button className="button button--transparent" type="button"
                                    onClick={() => this.props.toggleModal(false)}>
                                Cancel
                            </button>
                            <button className="button button--black" onClick={this.handleCreate}>
                                Create
                            </button>
                        </div>
                        }
                        {this.state.loading && <div className="loading-mask">
                            <Loading/>
                        </div>}
                    </div>
                </section>
            </div>
        )
    }
}

export default connect(null)(Functionality);
